import { render } from "./LocationMenu.vue?vue&type=template&id=33b0980c&scoped=true"
import script from "./LocationMenu.vue?vue&type=script&lang=js"
export * from "./LocationMenu.vue?vue&type=script&lang=js"

import "./LocationMenu.vue?vue&type=style&index=0&id=33b0980c&lang=css&scoped=true"

import exportComponent from "D:\\courses\\Web Design\\JAVA  SCRIPT\\Vue-js courses\\resturant\\mat-aem\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33b0980c"]])

export default __exports__